import { Box, Button, HStack, Modal, Text } from "native-base";
import * as React from "react";
import Colors from "../../const/Colors";
import { useTranslation } from "react-i18next";

const PopupMessage = ({
  ref,
  isOpen,
  onOk,
  onCancel,
  message,
}: {
  ref?: React.RefObject<any>;
  isOpen: boolean;
  onOk: () => void;
  onCancel?: () => void;
  message?: string;
}) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} background={"rgba(0,0,0,0.5)"}>
      <Modal.Content
        width={"90vw"}
        maxWidth={"90vw"}
        borderRadius={8}
        // bg={"red.200"}
      >
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
          <Text width={"100%"} fontSize={16} padding={4} textAlign={"center"}>
            {/*@ts-ignore*/}
            {t(message) ?? ""}
          </Text>
        </Box>
        <HStack display={"flex"}>
          {onCancel && (
            <Button
              flex={1}
              borderRadius={0}
              onPress={() => onCancel()}
              style={{
                backgroundColor: Colors.primaryColor,
              }}
            >
              <Text color="black" fontSize={16}>
                {t("Cancel")}
              </Text>
            </Button>
          )}
          {onCancel && <Box w={"1px"} />}
          <Button
            flex={1}
            borderRadius={0}
            onPress={() => onOk()}
            style={{
              backgroundColor: Colors.primaryColor,
            }}
          >
            <Text color="black" fontSize={16}>
              {t("OK")}
            </Text>
          </Button>
        </HStack>
      </Modal.Content>
    </Modal>
  );
};

export default PopupMessage;
